import { useQuery } from "@tanstack/react-query";
import { getMe } from "../services";

export function useMe(enabled: boolean) {
  return useQuery({
    queryKey: ["me"],
    queryFn: getMe,
    enabled,
  });
}
